/* Romantico cart drawer behaviors. Owned by Agent A.
   <rom-gift-message>: syncs the gift message textarea to a cart attribute,
   debounced, mirroring Dawn's CartNote pattern. The field also posts with
   checkout submission as a no-JS fallback. Re-initializes naturally after
   Section Rendering replaces the drawer contents (connectedCallback). */
if (!customElements.get('rom-gift-message')) {
  customElements.define(
    'rom-gift-message',
    class RomGiftMessage extends HTMLElement {
      connectedCallback() {
        const field = this.querySelector('textarea');
        if (!field) return;

        this.addEventListener(
          'input',
          debounce(() => {
            const body = JSON.stringify({ attributes: { 'Gift message': field.value } });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
